import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {FormLabel, FormLabelText} from '../../uninstallapp/uninstallCommonComponents';

export const Checkbox = memo(({ label, checked, ...props }) => (
    <CheckboxDiv>
        <FormLabel>
            <CheckboxContainer>
                <HiddenCheckbox checked = {checked} {...props} />
                <StyledCheckbox checked = {checked}>
                    <Icon viewBox='0 0 24 24'>
                        <polyline points='20 6 9 17 4 12' />
                    </Icon>
                </StyledCheckbox>
            </CheckboxContainer>
            <FormLabelText>{label}</FormLabelText>
        </FormLabel>
    </CheckboxDiv>
));

Checkbox.displayName = 'CheckBox';
Checkbox.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
};

const CheckboxContainer = styled.div`
    display: inline-block;
    vertical-align: middle;
`;

const Icon = styled.svg`
    fill: none;
    stroke: white;
    stroke-width: 2px;
`;

// Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually
const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
    border: 0;
    clip: rect(0 0 0 0);
    clippath: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
`;

const StyledCheckbox = styled.div`
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        transition: all 150ms;
        border: 2px solid rgba(255, 255, 255, 0.6);
        border-radius: 2px;
        ${HiddenCheckbox}:focus + & {
        box-shadow: 0 0 0 1px white;
    }

  ${Icon} {
        visibility: ${props => (props.checked ? 'visible' : 'hidden')}
    }
`;

const CheckboxDiv = styled.div`
    margin-bottom:18px;
`;
